export default __webpack_public_path__ + "static/media/sub-team-logo-default-fr.0caf6742.png";